// Single source of truth for the Clarion demo's published article.
//
// The content_provenance gig (gigs-newsroom.ts) hashes clarionArticleContent()
// into content_hash; the ContentCredential UI recomputes the SAME serialization
// and compares it to the sealed content_hash before it claims the story shown to
// the reader is the content the credential authenticates. Keeping one canonical
// serialization here is what makes "the story you're reading is the one this
// credential is for" a checkable statement rather than a hopeful one.
//
// Browser-safe: no heavy imports, so both the seal path and the browser UI can
// import it.

export const CLARION_ARTICLE_HEADLINE =
  "Regional authority approves drought-response plan for the lower basin";

export const CLARION_ARTICLE_LEDE = [
  "The regional water authority voted 6-1 on Thursday to adopt a drought-response plan that tightens allocation limits across the lower basin and funds three new recharge sites, according to the board's published minutes."
];

// The EXACT string sealed as content_hash: the headline (with a terminating
// period) followed by the lede paragraphs, joined by single spaces. The gig
// hashes this; the UI recomputes it and compares to the sealed evidence.
export function clarionArticleContent(): string {
  return [`${CLARION_ARTICLE_HEADLINE}.`, ...CLARION_ARTICLE_LEDE].join(" ");
}
